var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Registered"},[_c('p',{staticClass:"loginTitle"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"Registered-form"},[_c('p',{staticClass:"title"},[_vm._v("举报注册")]),_c('report',{attrs:{"reset":_vm.reset2}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }